import { Routes, Route, BrowserRouter } from "react-router-dom";
import PublicRoute from "../Components/PublicRoute";

// Componentes individuales
import ClientSign from "../Expedientes/ClientSign/ClientSign";
import NotFoundPage from "../Components/Common/NotFoundPage";

function ClientRoutes() {
  // Cuando ya exista userData, activamos el listener
  return (
    <Routes>
      {/* Rutas públicas */}
      <Route element={<PublicRoute />}>
        <Route path="/client-sign" element={<ClientSign />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default ClientRoutes;
